import * as TYPES from "../App/App.types";
import {getToken} from "../../../utils";

const stripePath = "stripe";
const paymentsPath = "payments";

export const createPaymentIntent = ({ amount, name, profileUrl, paymentMethodType }) => ({
  type: TYPES.CREATE_STRIPE_PAYMENT,
  request: {
    method: "POST",
    url: `${stripePath}/payment`,
    data: {
      amount,
      name,
      profileUrl,
      paymentMethodType
    }
  },
});

export const setClientSecret = (secret, id, paymentMethodType) => ({
  type: TYPES.SET_CLIENT_SECRET,
  payload: {
    secret,
    id,
    paymentMethodType
  }
})

export const updatePayment = ({ id, payment, status }) => ({
  type: TYPES.UPDATE_PAYMENT,
  request: {
    method: "PATCH",
    url: `${stripePath}/payment`,
    data: {
      id,
      payment,
      status
    }
  },
})

export const getPayments = () => ({
  type: TYPES.GET_PAYMENTS,
  request: {
    method: "GET",
    url: `${paymentsPath}`,
    headers: {
      authorization: getToken(),
    },
  },
})

export const getConnectToStripeLink = (callback) => ({
  type: TYPES.GET_CONNECT_TO_STRIPE_LINK,
  request: {
    method: "GET",
    url: `${stripePath}/authorize`,
    headers: {
      authorization: getToken(),
    },
  },
  callback
});

export const confirmStripeAccountToken = ({ token, callback }) => ({
  type: TYPES.CONFIRM_STRIPE_ACCOUNT,
  request: {
    method: "POST",
    url: `${stripePath}/authorize/token`,
    data: {
      token
    },
    headers: {
      authorization: getToken(),
    },
  },
  callback
});

export const createPayout = (callback, errorCallback) => ({
  type: TYPES.CREATE_PAYOUT,
  request: {
    method: "GET",
    url: `${paymentsPath}/payout`,
    headers: {
      authorization: getToken(),
    },
  },
  callback,
  errorCallback
})

export const redirectToStripeAccount = () => ({
  type: TYPES.REDIRECT_TO_STRIPE_ACCOUNT,
  request: {
    method: "GET",
    url: `${stripePath}/dashboard`,
    headers: {
      authorization: getToken(),
    },
  },
})
